import { useState } from 'react'
import Modal from '../../../../../components/modal/Modal'
import { deleteAPI } from '../../../../../utils/Api'
import { useGlobalContext } from '../../../../../utils/Context'
import FormLoader from '../../../../../components/loader/FormLoader'

function DeleteZone({ showDelete, setShowDelete, fetchRates }: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const deleteZone = async () => {
    setLoading(true)
    deleteAPI(`zonerates/delete?id=${showDelete}`)
      .then((result: any) => {
        if (result.status === 200) {
          setLoading(false)
          notify('success', result.message)
          fetchRates()
          setShowDelete(null)
        } else {
          notify('error', result.message)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Delete Zone</h1>
        <p>Are you sure you want to delete this Zone?</p>
        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowDelete(null)}>Cancel</button>
            <button className='proceed' onClick={deleteZone}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default DeleteZone
